module.exports = __webpack_public_path__ + "470a9e2b412c2f4309045274dba21f.png";